export const CONSENT_VERSION = "2026-10-15";
export const COOKIE_KEY = "fokeev_cookie_choice_v2";
const MAX_AGE = 180 * 24 * 60 * 60 * 1000;
let started = false;

export function readCookieChoice() {
  try {
    const value = JSON.parse(localStorage.getItem(COOKIE_KEY));
    if (value?.version === CONSENT_VERSION && ["accepted", "rejected"].includes(value.choice)
      && Date.now() - value.at < MAX_AGE && value.at <= Date.now()) return value.choice;
  } catch { /* Unavailable storage means no consent. */ }
  return null;
}

export function clearAnalyticsCookies() {
  for (const entry of document.cookie.split(";")) {
    const name = entry.split("=")[0].trim();
    if (!/^(_ym_|_ga|_gid|_gat|ph_)/.test(name)) continue;
    const host = window.location.hostname;
    for (const domain of ["", `; domain=${host}`, `; domain=.${host}`]) {
      document.cookie = `${name}=; Max-Age=0; path=/${domain}; SameSite=Lax`;
    }
  }
  try {
    for (const key of Object.keys(localStorage)) {
      if (/^(ph_|_ym)/.test(key)) localStorage.removeItem(key);
    }
    localStorage.removeItem("cookie_consent_accepted");
  } catch { /* Storage can be blocked. */ }
}

export function startAnalytics() {
  if (started || readCookieChoice() !== "accepted") return;
  started = true;
  window.ym = window.ym || function () { (window.ym.a = window.ym.a || []).push(arguments); };
  window.ym.l = Date.now();
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://mc.yandex.ru/metrika/tag.js?id=107179621";
  document.head.appendChild(script);
  window.ym(107179621, "init", {
    webvisor: false, clickmap: false, trackLinks: false, accurateTrackBounce: true,
    // Avoid sending query strings, fragments or checkout identifiers.
    url: window.location.origin + window.location.pathname,
    referrer: document.referrer ? new URL(document.referrer).origin : "",
  });
}

export function saveCookieChoice(choice) {
  try {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ choice, version: CONSENT_VERSION, at: Date.now() }));
  } catch { return false; }
  if (choice === "accepted") startAnalytics();
  else {
    if (started && typeof window.ym === "function") window.ym(107179621, "destruct");
    clearAnalyticsCookies();
    if (started) window.location.reload();
  }
  return true;
}
